export default function ensureNewVisibleColumnSortOrder(newColumns, allColumns) {
  return allColumns.filter(column => newColumns.indexOf(column) !== -1);
}
